"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatValues = exports.keyEq = exports.keyCmp = exports.contentLength = exports.contentChars = exports.length = exports.isEmpty = exports.fromKey = exports.toKey = exports.toString = exports.nodeToString = void 0;
exports.nodeToString = function (state, node) {
    return ((node.deleted || node.content.type !== 'text' ? '' : node.content.text) +
        node.children.map(child => exports.nodeToString(state, state.map[child])).join(''));
};
exports.toString = function (crdt) {
    return crdt.roots.map(root => exports.nodeToString(crdt, crdt.map[root])).join('');
};
exports.toKey = ([id, site]) => `${id}:${site}`;
exports.fromKey = (id) => {
    const [a0, a1] = id.split(':');
    return [+a0, a1];
};
exports.isEmpty = function (state) {
    for (let i = 0; i < state.roots.length; i++) {
        if (state.map[state.roots[i]].size > 0) {
            return false;
        }
    }
    return true;
};
exports.length = function (state) {
    let res = 0;
    state.roots.forEach(r => (res += state.map[r].size));
    return res;
};
exports.contentChars = (content) => {
    switch (content.type) {
        case 'text':
            return content.text.length;
        default:
            return 0;
    }
};
exports.contentLength = (content) => {
    switch (content.type) {
        case 'text':
            return content.text.length;
        default:
            return 1;
    }
};
// export const strKeyCmp = (a: string, b: string): number => {
//     const [a0, a1] = a.split(':');
//     const [b0, b1] = b.split(':');
//     return keyCmp([+a0, a1], [+b0, b1]);
// };
exports.keyCmp = ([a, b], [c, d]) => {
    return a < c ? -1 : a > c ? 1 : b < d ? -1 : b > d ? 1 : 0;
};
exports.keyEq = ([a, b], [c, d]) => {
    return a === c && b === d;
};
exports.getFormatValues = (state, formats) => {
    const res = {};
    Object.keys(formats).forEach(key => {
        if (formats[key].length) {
            const node = state.map[formats[key][0]];
            if (node.content.type !== 'open') {
                throw new Error(`A formats list had a non-open node in it ${exports.toKey(node.id)}`);
            }
            res[key] = node.content.value;
        }
    });
    return res;
};
